import { useState, useEffect } from 'react';

const RelatorioTarefas = ({ tarefas }) => {
    const [tarefasCriticas, setTarefasCriticas] = useState([]);

    useEffect(() => {
        const hoje = new Date();
        const tarefasFiltradas = tarefas.filter(tarefa => {
            const prazo = new Date(tarefa.info.data_limite);
            const diferenca = Math.ceil((prazo - hoje) / (1000 * 60 * 60 * 24));
            return diferenca <= 1; // Apenas tarefas com 1 dia ou menos para expirar ou já expiradas
        });

        setTarefasCriticas(tarefasFiltradas);
    }, [tarefas]);

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: 'auto' }}>
            <h2 style={{ textAlign: 'center', color: '#d9534f' }}>Tarefas Críticas</h2>
            <div>
                {tarefasCriticas.length > 0 ? tarefasCriticas.map(tarefa => (
                    <div key={tarefa.id} style={{
                        border: '2px solid #d9534f',
                        padding: '10px',
                        marginBottom: '10px',
                        borderRadius: '5px',
                        backgroundColor: '#f8d7da',
                        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)'
                    }}>
                        <h4 style={{ margin: '0 0 5px 0', color: '#721c24' }}>{tarefa.info.name}</h4>
                        <p style={{ margin: '0 0 5px 0', color: '#666' }}>Estado: {tarefa.info.estado.labelPt}</p>
                        <p style={{ color: '#721c24', fontWeight: 'bold' }}>Prazo: {tarefa.info.data_limite}</p>
                    </div>
                )) : (
                    <p style={{ textAlign: 'center', color: '#666' }}>Não há tarefas críticas no momento.</p>
                )}
            </div>
        </div>
    );
};

export default RelatorioTarefas;
